export class ProjectEntity {}
